import React from "react";
import Layout from "./Componets/Layout"
import './App.css';

 const App = () => {
  return (

    <>
         <Layout/>
    </>
  );
}





export default App;